<div class="row">
  <div class="col-md-3">
    <h3>Select file</h3>
    <div
      ng2FileDrop
      [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
      (fileOver)="fileOverBase($event)"
      [uploader]="uploader"
      (click)="openFileDialog()"
      class="well drop-zone"
    >
      File drop zone
    </div>
    <button
      type="button"
      class="btn btn-success btn-lg"
      (click)="openFileDialog()"
      style="width: 100%"
    >
      <i class="fa fa-plus"></i> Select File
    </button>
    <input
      type="file"
      ng2FileSelect
      [uploader]="uploader"
      style="display: none"
      #fileInput
      (click)="onFileClick($event)"
    />
  </div>
  <div class="col-md-9" style="margin-bottom: 40px">
    <h3>Upload queue</h3>
    <table class="table">
      <thead>
        <tr>
          <th width="50%">Name</th>
          <th>Size</th>
          <th>Progress</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of uploader?.queue">
          <td class="data">
            <strong>{{ item?.file?.name }}</strong>
          </td>
          <td class="data" nowrap>{{ getFileSize(item?.file?.size) }}</td>
          <td class="databtn">
            <div class="progress" style="margin-bottom: 0">
              <div
                class="progress-bar"
                role="progressbar"
                [ngStyle]="{ width: item.progress + '%' }"
              ></div>
            </div>
          </td>
          <td class="text-center data">
            <span *ngIf="item.isSuccess">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            <span *ngIf="item.isCancel">
              <i class="glyphicon glyphicon-ban-circle"></i>
            </span>
            <span *ngIf="item.isError">
              <i class="glyphicon glyphicon-remove"></i>
            </span>
          </td>
          <td nowrap class="databtn">
            <button
              type="button"
              class="btn btn-success btn-xs"
              (click)="itemUpload(item)"
              [disabled]="item.isReady || item.isUploading || item.isSuccess"
            >
              <i class="fa fa-upload"></i> Upload
            </button>
            <button
              type="button"
              class="btn btn-warning btn-xs"
              (click)="itemCancel(item)"
              [disabled]="!item.isUploading"
            >
              <i class="fa fa-ban"></i> Cancel
            </button>
            <button type="button" class="btn btn-danger btn-xs" (click)="itemRemove(item)">
              <i class="fa fa-trash"></i> Remove
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
